import { useState, useEffect } from 'react'
import Card from '../components/Card'

const units = {
  'm/s': { name: 'Meter per Second', factor: 1 },
  'km/h': { name: 'Kilometer per Hour', factor: 0.277778 },
  'mph': { name: 'Mile per Hour', factor: 0.44704 },
  'ft/s': { name: 'Foot per Second', factor: 0.3048 },
  'knot': { name: 'Knot', factor: 0.514444 },
  'mach': { name: 'Mach', factor: 343 },
}

export default function SpeedConverter() {
  const [fromUnit, setFromUnit] = useState('km/h')
  const [toUnit, setToUnit] = useState('mph')
  const [fromValue, setFromValue] = useState('')
  const [toValue, setToValue] = useState('')

  const convert = () => {
    if (!fromValue || isNaN(fromValue)) {
      setToValue('')
      return
    }

    const value = parseFloat(fromValue)
    const fromFactor = units[fromUnit].factor
    const toFactor = units[toUnit].factor

    const metersPerSecond = value * fromFactor
    const result = metersPerSecond / toFactor

    setToValue(result.toFixed(6).replace(/\.?0+$/, ''))
  }

  useEffect(() => {
    convert()
  }, [fromUnit, toUnit, fromValue])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label">From:</label>
              <select
                value={fromUnit}
                onChange={(e) => setFromUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="number"
                value={fromValue}
                onChange={(e) => setFromValue(e.target.value)}
                className="input w-full mt-3"
                placeholder="Enter value"
                step="any"
              />
            </div>
            <div>
              <label className="label">To:</label>
              <select
                value={toUnit}
                onChange={(e) => setToUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="text"
                value={toValue}
                readOnly
                className="input w-full mt-3 bg-gray-50"
                placeholder="Result"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

